import { Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface DarkRankingItem {
  name:      string;
  value:     number;          // ej. aprobados
  pct?:      number;          // 0-100 para la barra. Si no viene se calcula vs maxValue
  sublabel?: string;          // texto opcional debajo del nombre
}

export interface DarkRankingConfig {
  title:       string;
  valueLabel?: string;        // unidad al lado del número  ej. "aprob."
  items:       DarkRankingItem[];
  maxVisible?: number;        // cuántos mostrar (default 7)
  showMedal?:  boolean;       // mostrar 🥇🥈🥉 en top 3 (default true)
}

interface RankRow extends DarkRankingItem {
  rank:     number;
  barPct:   number;           // porcentaje calculado para la barra
  barColor: string;
  medal:    string;
}

@Component({
  selector: 'app-dark-ranking-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dark-ranking-card.component.html',
  styleUrl:    './dark-ranking-card.component.scss',
})
export class DarkRankingCardComponent implements OnChanges {
  @Input() config!: DarkRankingConfig;

  rows: RankRow[] = [];

  ngOnChanges(): void {
    this.build();
  }

  private build(): void {
    if (!this.config?.items?.length) { this.rows = []; return; }

    const maxVisible = this.config.maxVisible ?? 7;
    const items      = [...this.config.items]
      .sort((a, b) => b.value - a.value)
      .slice(0, maxVisible);

    const maxVal = items[0]?.value || 1;
    const medals = ['🥇', '🥈', '🥉'];

    this.rows = items.map((item, i) => {
      // Si el item ya trae pct (0-100) lo usamos, si no calculamos vs max
      const barPct   = item.pct !== undefined
        ? Math.min(item.pct, 100)
        : (item.value / maxVal) * 100;

      // Color semáforo cuando hay pct real de cumplimiento
      const hasCump  = item.pct !== undefined;
      const barColor = hasCump
        ? (item.pct! >= 100 ? '#4ade80' : item.pct! >= 80 ? '#fb923c' : '#f87171')
        : this.paletteColor(i);

      return {
        ...item,
        rank:     i + 1,
        barPct,
        barColor,
        medal:    (this.config.showMedal !== false && i < 3) ? medals[i] : '',
      };
    });
  }

  private paletteColor(index: number): string {
    const palette = ['#6366f1', '#38bdf8', '#34d399', '#fb923c', '#f472b6', '#a78bfa', '#facc15'];
    return palette[index % palette.length];
  }

  formatValue(v: number): string {
    return v.toLocaleString('es-CO');
  }
}
